export default "__VITE_ASSET__DqpgiZKu__"